import React, { useEffect, useState } from "react";
import { Breadcrumb, PageHeader, Table, Spin, message, Button } from "antd";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import { creditVoucherService } from "_services/creditvoucher.service";
import { CurrencyFormatter } from "_helpers/formatters";
import Search from "./Search";

function List({ match }) {
  const { path } = match;
  const [vouchers, setVouchers] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    getAllCreditVouchers();
  }, []);

  const getAllCreditVouchers = () => {
    setLoading(true);

    creditVoucherService
      .getAll()
      .then((data) => {
        setVouchers(data.content);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        message.error(error);
      });
  };

  const getActionButtons = () => {
    let buttons = [];
    buttons.push(
      <Link to={`${path}/add`} key="btn-add gurantee">
        <Button>Add</Button>
      </Link>
    );
    return buttons;
  };

  const columns = [
    {
      title: "Voucher Number",
      dataIndex: ["voucherNumber"],
      key: "voucherNumber",
      width: "10%",
      render: (text, record) => (
        <Link to={`/credit-vouchers/${record.id}/summary`}>
          {text ?? "N/A"}
        </Link>
      ),
    },
    {
      title: "Date",
      dataIndex: ["receivedDate"],
      key: "receivedDate",
      width: "10%",
    },
    {
      title: "Custom Ref No#",
      dataIndex: ["stockIssue", "customReferenceNumber"],
      key: "receivedDate",
      width: "10%",
      render: (text, record) => text ?? "INVALID",
    },
    // {
    //   title: "Delivery No#",
    //   dataIndex: ["deliveryNumber"],
    //   key: "deliveryNumber",
    //   width: "10%",
    //   render: (text, record) => text ?? "N/A",
    // },
    {
      title: "Amount",
      dataIndex: ["creditAmount"],
      key: "creditAmount",
      width: "10%",
      render: (text, record) => CurrencyFormatter(text ?? 0),
    },
  ];
  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/dashboard">Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/credit-vouchers">Credit Vouchers</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Page inner>
        <Search />
        <Spin spinning={loading}>
          <Table columns={columns} dataSource={vouchers} />
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default List;
